(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patient-group', {
            parent: 'entity',
            url: '/patient-group',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'PatientGroups'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient-group/patient-groups.html',
                    controller: 'PatientGroupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                clinic: ['CoreService', function (CoreService) {
                    return CoreService.getCurrentClinic();
                }]
            }
        })
        .state('patient-group-detail', {
            parent: 'patient-group',
            url: '/patient-group/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'PatientGroup'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient-group/patient-group-detail.html',
                    controller: 'PatientGroupDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PatientGroup', function($stateParams, PatientGroup) {
                    return PatientGroup.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'patient-group',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('patient-group-detail.edit', {
            parent: 'patient-group-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-group/patient-group-dialog.html',
                    controller: 'PatientGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatientGroup', function(PatientGroup) {
                            return PatientGroup.get({id : $stateParams.id}).$promise;
                        }],
                        clinic: ['CoreService', function (CoreService) {
                            return CoreService.getCurrentClinic();
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patient-group.new', {
            parent: 'patient-group',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-group/patient-group-dialog.html',
                    controller: 'PatientGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CoreService', function (CoreService) {
                            return {
                                name: null,
                                id: null,
                                clinic: CoreService.getCurrentClinic()
                            };
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-group', null, { reload: 'patient-group' });
                }, function() {
                    $state.go('patient-group');
                });
            }]
        })
        .state('patient-group.edit', {
            parent: 'patient-group',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-group/patient-group-dialog.html',
                    controller: 'PatientGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatientGroup', function(PatientGroup) {
                            return PatientGroup.get({id : $stateParams.id}).$promise;
                        }],
                        clinic: ['CoreService', function (CoreService) {
                            return CoreService.getCurrentClinic();
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-group', null, { reload: 'patient-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patient-group.delete', {
            parent: 'patient-group',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-group/patient-group-delete-dialog.html',
                    controller: 'PatientGroupDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PatientGroup', function(PatientGroup) {
                            return PatientGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-group', null, { reload: 'patient-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
